<template lang='pug'>
.page-wrapper
    Navbar
    .content-wrapper
        Loader(v-if='isLoading')
        .content
        h1 Privacy Policy
        h3 What information do we collect?
        div 
            | When you sign up as a member of Reward Deals we store your e-mail address and chosen username so that we can contact you where necessary in regards to the administration of your account. By registering you also agree to receive our regular email newsletter from which you may opt-out at any time (via the email footer opt-out button) contained in each email. If you register via Facebook you'll have an option to choose what information you provide us. By default, Facebook sends us what is referred to as your "public profile" information. This can include your email address, full name, profile picture, gender and age range. Whilst signing up you can choose what information is shared with us and opt out if you would prefer.
            | We also store users' IP addresses. We do this for the sole purpose of preventing malicious use of the Reward Deals platform and to ensure our <a href="https://rewarddeals.co.uk/more/guidelines">community guidelines</a> are enforced. For example, we may use the IP address to detect advertisers / retailers who sign up for multiple accounts in an attempt to unscrupulously promote their own services.
            | For the purposes of administering rewards and for functionality in the future (e.g. personalized deals feed) we store information about some purchases made through the Reward Deals website. This may include products purchased, amount spent and other associated transaction information.
            | If you choose to sign up for our WhatsApp and Telegram notifications your mobile number is stored so that we can send you messages.

        h3 Who is collecting the data and who is it shared with?
        div
            | We (Reward Deals LLP) hold your data and do not share it with any third parties other than set out below: 
            | Our website uses Google Analytics to analyse how users interact with the site. This is standard practice for most modern websites. 
            | It helps us keep track of the number of visitors to Reward Deals and allows us to analyze trends. You can read more about Google Analytics at their website, here. 
            | We use a services called Mailgun (Sinch Email Services) to manage our email newsletter subscriptions. We share your email address and, if you provided it to us, your name with Mailgun. 
            | This allows us to send you personalised emails. We also use Mailgun to let us know how people interact with our emails - e.g. if/when they're opened and what links are clicked. 
            | We use this information to try and improve our emails so they're as useful as possible. If you sign up to our WhatsApp notifications, 
            | your mobile number and any interactions with us via WhatsApp are handled and stored by a third party service called MessengerPeople. 
            | For full information about how any third party processes and handles information please refer to their respective privacy policy and terms.

        h3 Why is the data collected?
        div 
            | We ask for your email address so that we can contact you when required. As outlined above, your IP address is stored to help prevent the abuse of our platform. Any other information is used to help improve Reward Deals  and tailor our content to our visitors.
            | For full details of why data is collected by the third party services we use, please review their privacy policies from the website links above.
        
        h4 Getting a copy of your personal information
        div
            | You're welcome to <a href="mailto:support@rewarddeals.co.uk">email us</a> if you would like a copy of your personal information that we hold.

        h3 What if my personal information is incorrect?
        div 
            | If you believe any of the information that we hold (e.g. your email address) is incorrect you can <a href="mailto:support@rewarddeals.co.uk">email us</a> to let us know and we'll make sure it's up to date.

        h3 How can I delete my account and/or personal information?
        div 
            | If you would like to delete your Reward Deals account and remove all personal data stored, <a href="mailto:support@rewarddeals.co.uk">email us</a> and title the email  'Delete My Account'.
            | Please note that WhatsApp notifications are not linked to your Reward Deals account. If you would like to unsubscribe please type "STOP" to the respective service.

        h3 Cookies
        div We use cookies on Reward Deals. <a href="https://rewarddeals.co.uk/legal/cookie_policy">Find out more.</a>

        h3 Third party websites
        div We do not sell any products or services - we are a community that links to the hotukdeals and offers at various retailers (e.g. Amazon, eBay etc). As these are third party websites not under our control we encourage you to check their privacy policy before providing any personal data. Notice that you can identify when you have left Reward Deals as the URL will no longer be www.rewarddeals.co.uk.

        h3 Sharing deals & commenting
        div If you share a deal or comment on our website then you are free to share your opinions. However, we recommend that you avoid sharing any personal information. If you see something on our site that you're not happy about, contact us and we'll do our best to address any concerns.

        h3 Changes to this privacy policy
        div We may update this policy from time to time. We therefore recommend that you review this page periodically for any changes. Any such changes are effective as soon as they are published to this page.

        h3 Contacting us
        div If you have any questions about our privacy policy please <a href="mailto:support@rewarddeals.co.uk">email us</a> and we'll do our best to help.

        h5 RewardDeals.co.uk
        h7 Share a great deal to earn a great deal!

    Footer
</template>

<style lang='stylus' scoped>
@import "../../stylus/mixins.styl";

.content-wrapper
    flexbox(column, flex-start, flex-start)
    margin 30px 300px

    @media (max-width: 800px) 
        margin 30px 10px
        overflow auto
    padding 20px
    background-color white
    img
        width 300px
        self-align center

    .image
        text-align center

</style>

<script>
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default {
    components: {
        Navbar,
        Footer,
    },

};
</script>
